import { LinearProgress } from '@mui/material';
import { useOktaAuth } from '@okta/okta-react';
import { Redirect } from 'react-router-dom';

import { settings } from 'config/settings';
import { useUserContext } from 'hooks/useUserContext';

export const Home = () => {
  const { user } = useUserContext();
  const { oktaAuth } = useOktaAuth();
  if (!user) {
    return <LinearProgress />;
  }

  const signOut = async () => {
    await oktaAuth.signOut({
      clearTokensBeforeRedirect: true,
      postLogoutRedirectUri: settings.APP_ORIGINAL_URI + '/home/user/inactive',
      state: 'logged_out',
    });
  };
  if (user.account_status === 'disabled') {
    signOut();
  }
  switch (user.role) {
    case 'candidate_admin':
      return (
        <Redirect to='/home/candidate_admin_dashboard/reviewed_candidates' />
      );
    case 'employer':
      return <Redirect to='/home/employer_dashboard/candidates' />;
    case 'signer':
      return <Redirect to='/home/signer_dashboard/tranches' />;
    case 'system_admin':
      return <Redirect to='/home/system_admin_dashboard/users' />;
    case 'auditor':
      return <Redirect to='/home/auditor_dashboard/tranches' />;
    default:
      return <Redirect to='/home/admin/403' />;
  }
};
